import api from '@/api';
import router from '@/router';
import i18n from '@/lang';
import { useAuthStore } from '@/stores/auth';

let isHandlingSessionExpiry = false;

/**
 * Intercepts expired session / CSRF responses so the user is redirected
 * to login with a clear message instead of seeing "CSRF token mismatch."
 */
export function setupSessionExpiryHandler() {
  api.apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status;

      if (status === 419) {
        const message = String(i18n.global.t('auth.session.expired'));

        if (error.response?.data && typeof error.response.data === 'object') {
          error.response.data.message = message;
        }

        const url = String(error?.config?.url || '');
        const isAuthRequest = /\/(login|logout|register|forgot-password|reset-password)/.test(url);
        const onLoginPage = router.currentRoute.value.name === 'login';

        if (!isAuthRequest && !onLoginPage && !isHandlingSessionExpiry) {
          isHandlingSessionExpiry = true;

          try {
            const authStore = useAuthStore();
            await authStore.setUser(null);
            await authStore.setLogged(false);
            await authStore.setAgency(null);

            await router.replace({
              name: 'login',
              query: { redirect: router.currentRoute.value.fullPath },
            });
          } finally {
            isHandlingSessionExpiry = false;
          }
        }
      }

      return Promise.reject(error);
    },
  );
}
